// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5662) return "static/chunks/5662-aace2af3dfa87315.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"535":"06cff297a5de4c16","758":"acdbadd82a930bfb","2916":"fc964b4fcd543109","9745":"96063c02692e92da"}[chunkId] + ".js";
};